module.exports = __webpack_public_path__ + "img/419-496f4c.png";